import React from 'react';
import Header from '../components/Header';
import SEO from '../components/SEO';

const ExecutiveMirrorProductPage = () => {
  return (
    <div className="min-h-screen bg-white flex flex-col">
      <SEO 
        title="Executive Assessment Nigeria | Executive Mirror™ Lagos"
        description="Executive Mirror™ assessment for Nigerian executives. See how an executive shapes the organisation around them. A deeper leadership portrait built for African senior leaders."
        keywords="executive assessment Nigeria, executive leadership Lagos, senior leader assessment Nigeria, executive mirror Africa, C-suite assessment"
        canonical="https://impactasportal.com/product/executive-mirror"
      />
      <Header />
      
      {/* Main Content - Iframe Container */}
      <main className="flex-1 pt-20">
        <div className="w-full h-[calc(100vh-80px)]">
          <iframe
            src="https://impactasportal.com/product/executive-mirror?embed=true"
            title="Executive Mirror™ - Impact AS Plus"
            className="w-full h-full border-0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; fullscreen"
            allowFullScreen
            sandbox="allow-same-origin allow-scripts allow-popups allow-forms allow-downloads allow-modals allow-popups-to-escape-sandbox"
          />
        </div>
      </main>
    </div>
  );
};

export default ExecutiveMirrorProductPage;
